import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';

import { Subscription } from 'rxjs';
import {
  ActionMode,
  ActionModeType,
  DataBroadcast,
  DataBroadcastModel,
  GenerateFormFieldModel,
  GenerateFormModel
} from 'src/app/model';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-generate-form',
  templateUrl: './generate-form.component.html',
  styleUrls: ['./generate-form.component.css']
})
export class GenerateFormComponent implements OnInit, OnDestroy {

  @Output() formGenerated = new EventEmitter<GenerateFormModel>();

  @Input()
  set formFields(value: GenerateFormFieldModel[]) {
    this._formFields = value;
    this._createForm();
  }

  get formFields() {
    return this._formFields;
  }

  // Form
  form = new UntypedFormGroup({});
  masterFormField: GenerateFormFieldModel[] = [] as GenerateFormFieldModel[];

  // Flag
  isButtonPresent: boolean = true;
  isPushNotification: boolean = false;

  // Setter
  private _formFields: GenerateFormFieldModel[];

  // Miscellaneous
  readonly ACTION_MODE = ActionMode;
  
  // Subscription
  private _subscription: Subscription;

  constructor(
    private _dataSer: DataService
  ) {
    // Broadcast
    this._subscription = this._dataSer.events
    .subscribe({
      next: (broadcast: DataBroadcastModel) => {
        if (broadcast.name === DataBroadcast?.SITE_CHANGED || broadcast.name === DataBroadcast?.API_REFRESH) {
          this.form.reset();
        }
      }
    });
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  /**
   * Determines whether select option click on
   * @param control
   */
  onSelectOptionClick(control: string) {
    if (this.form.value.toUser && this.form.value.toUser.length) {
      if (Object.keys(this.form.value).includes('email')) {
        const emailList = this.form.value.toUser.map((elem: any) => elem.email ? elem.email : '');
        this.form.controls['email'].setValue(emailList);
      } else if (Object.keys(this.form.value).includes('phoneNumber')) {
        const numberList = this.form.value.toUser.map((elem: any) => elem?.phone?.number ? ('' + elem?.phone?.countryCode) + ('' + elem?.phone?.number) : '');
        this.form.controls['phoneNumber'].setValue(numberList);
      }
    }
  }

  /**
   * Determines whether submit on
   * @param [actionType]
   */
  onSubmit(actionType: ActionModeType = ActionMode.SUBMIT) {
    if (actionType === ActionMode.SUBMIT) {
      if (this.form.valid) {
        this.formGenerated.emit({ formValue: this.form.value, actionType: actionType });
      }
    } else if (actionType === ActionMode.CLEAR) {
      this.form.reset();
      this.formGenerated.emit({ formValue: this.form.value, actionType: actionType });
    } else {
      this.formGenerated.emit({ formValue: null, actionType: actionType });
    }
  }

  /**
   * Sets panel class
   * @param isMultiSelect
   * @returns panel class
   */
  setPanelClass(isMultiSelect: boolean): string {
    return isMultiSelect ? 'multiSelectPanel' : '';
  }

  /**
   * Gets validator
   * @param [validator]
   * @returns validator
   */
  private _getValidator(validator: 'email' | 'required' = null): ValidatorFn | null {
    switch (validator) {
      case 'email':
        return Validators.email;
      case 'required':
        return Validators.required;
      default:
        return null;
    }
  }

  /**
   * Creates form
   */
  private _createForm() {
    this.form = new UntypedFormGroup({});
    this.isPushNotification = false;
    this.formFields?.forEach((formField) => {
      if (formField?.displayId === 'push') {
        this.isPushNotification = true;
      }
      this.form.addControl(
        formField?.path,
        new UntypedFormControl(formField?.initialValue ?? '', this._getValidator(formField?.validator))
      );
    });
    this.masterFormField = [...this.formFields];
  }
}
